import logoUrl from "../assets/ELGUARDS_LOGO-02.png";

export default function CornerLogo() {
  return (
    <div className="cornerLogo" aria-hidden="true">
      <img src={logoUrl} alt="" />
    </div>
  );
}
